import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { RegisterService } from '@app/_services/register.service';
import { Register } from '@app/_models/register';
import { Observable, of } from 'rxjs';
import { NgxSpinnerService } from "ngx-spinner";
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-register-student',
  templateUrl: './register-student.component.html',
  styleUrls: ['./register-student.component.css']
})
export class RegisterStudentComponent implements OnInit {
  recaptchaSiteKey = environment.recaptchaSiteKey;
  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$";//"^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";
  // Register: Register;
  registerForm: FormGroup;
  submitted = false;
  returnUrl;
  showModalBox: boolean = false;
  showModalBoxCheck: boolean = false;
  //template:Template;
  //public modalRef: BsModalRef;
  invalidCaptcha: string;

  Register = new Register();
  getresponse: any;
  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;

  resolved(captchaResponse: string) {
    console.log(`Resolved captcha with response: ${captchaResponse}`);
    this.invalidCaptcha = "";
  }

  submitMessage: string;
  form: FormGroup;

  constructor(private formBuilder: FormBuilder, private router: Router,
    private registerService: RegisterService,
    public fb: FormBuilder,
    private SpinnerService: NgxSpinnerService,
    private modalService: NgbModal
  ) {

    this.form = this.fb.group({
      firstName: [''],
      lastName: [''],
      emailId: [''],
      phoneNumber: [''],
      password: [''],
      rePassword: [''],
      recaptchaReactive: [''],
      city: [''],
      pincode: [''],
      state: [''],
      country: [''],
      address: ['']
    })
  }

  //only number will be add
  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  ngOnInit() {

    this.registerForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      emailId: ['', Validators.required],
      password: ['', Validators.required],
      rePassword: ['', Validators.required],
      city: ['', Validators.required],
      pincode: ['', Validators.required],
      state: ['', Validators.required],
      address: ['', Validators.required],
      country: ['', Validators.required],
      phoneNumber: ['', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(10), Validators.maxLength(10)]],
      roleId: ['1'],
      cb: [false, Validators.requiredTrue]
      // recaptchaReactive: ['', Validators.required]

    });
  }
  openPdf(){
    // var fileURL: any = URL.createObjectURL(blob);
    // var a = document.createElement("a");
    // a.href = fileURL;
    // a.target = '_blank';
    // // Don't set download attribute
    // // a.download = "Example.pdf";
    // a.click();
    // window.open(this.fileURL);
  }

  get f() { return this.registerForm.controls; }

  refresh(): void {
    location.reload();
  }

  submitForm() {
    //this.modalService.open(this.showModalBoxTemplate);
    this.submitted = true;
    var res = $('#g-recaptcha-response').val();
    // stop here if form is invalid
    if (this.registerForm.invalid) {
      this.showModalBox = false;
      if (res == "") {
        this.invalidCaptcha = "Please click on recaptcha";
        return;
      }
      else {
        if (this.registerForm.invalid) { this.showModalBox = false; return; }
        this.invalidCaptcha = "";
      }
    }

    if (res == "") {
      this.invalidCaptcha = "Please click on recaptcha";
      return;
    }
    this.getdata();
    this.SpinnerService.show();
    this.invalidCaptcha = "";
    this.submitMessage = "";
    // if(this.getresponse)
    // {
    //   this.showModalBox = true;  
    // }

  }

  private fetchData() {
    const promise = this.registerService.addRegister(this.Register).toPromise();
    console.log(promise);
    promise.then((data) => {
      this.showModalBox = true;
      console.log("Promise resolved with: " + JSON.stringify(data));
    }).catch((error) => {
      console.log("Promise rejected with " + JSON.stringify(error));
    });
  }

  getdata() {
    this.registerService.addRegister(this.Register)
      .subscribe((response) => {
        if (response) {

          this.getresponse = response;
          if (this.getresponse.respMessage == "Success") {
            // this.showModalBox = true;  
            console.log("std reg res =", response);
            //this.invalidCaptcha = "Email is sent to you for verification. Please verify your mail.";
            this.invalidCaptcha = "";
            this.submitMessage = "";
            this.SpinnerService.hide();
            //alert("Email is sent to you for verification. Please verify your mail.");
            this.modalService.open(this.showModalBoxTemplate);
            // this.showModalBox = true; 
            // location.reload();
            // this.returnUrl = "studentRegister";
            // this.router.navigate([this.returnUrl]);
            // this.returnUrl = "login";
            // this.router.navigate([this.returnUrl]);
            // this.registerForm.reset();
            // this.registerForm.clearValidators();

            // Reset values for next time

            // this.f.firstName.setValue('');
          }
          else {
            this.SpinnerService.hide();
            this.submitMessage = this.getresponse.respData;
          }
        }
        else {
          this.SpinnerService.hide();
        }
      },
        (err: any) => {
          this.SpinnerService.hide();
          var message = err;
          this.showModalBox = false;
          this.invalidCaptcha = "Invalid";
          // alert("Error Message"+ err);
        });
  }

}
